export default "__VITE_ASSET__BVu_oCYm__"